<div class="overlay" id="message-overlay" *ngIf="isVisible$ | async">
    <div class="overlay-content" [ngClass]="type$ | async">
      <span class="close-btn" (click)="messageService.hideMessage()">&times;</span>
      <p>{{ message$ | async }}</p>
   
    </div>
    
    
  </div>
